import getElementsOutsideLimits from "../../containers/domain/getElementsOutsideLimits";
import {
    removeBlockOut as removeLidBlockOut,
    removeCircularBlockOut as removeLidCircularBlockOut,
    removeManhole
} from "../lid/lidSlice";
import {
    removeBlockOut as removeIntermediateCeilingBlockOut,
    removeCircularBlockOut as removeIntermediateCeilingCircularBlockOut
} from "../intermediateCeiling/intermediateCeilingSlice";
import {removeBlockOut, removeCRail, removeGrounding, removeSleeve, removeWallDrainage} from "../vault/vaultSlice";
import {removeDrainage} from "../floor/floorSlice";

export const removeElementsOutsideLimits = () => (dispatch, getState) => {
    const {lid, intermediateCeiling, vault, floor} = getElementsOutsideLimits(getState().plan)

    if (lid) {
        lid.manholes.forEach(manhole => dispatch(removeManhole({id: manhole.id})))
        lid.blockOuts.forEach(blockOut => dispatch(removeLidBlockOut({id: blockOut.id})))
        lid.circularBlockOuts.forEach(blockOut => dispatch(removeLidCircularBlockOut({id: blockOut.id})))
    }
    if (intermediateCeiling) {
        intermediateCeiling.blockOuts
            .forEach(blockOut => dispatch(removeIntermediateCeilingBlockOut({id: blockOut.id})))
        intermediateCeiling.circularBlockOuts
            .forEach(blockOut => dispatch(removeIntermediateCeilingCircularBlockOut({id: blockOut.id})))
    }
    if (vault) {
        vault.walls.forEach((wall, wallIndex) => {
            const {sleeves, blockOuts, cRails, groundings, drainages} = wall

            sleeves.forEach(sleeve => dispatch(removeSleeve({wallIndex, id: sleeve.id})))
            blockOuts.forEach(blockOut => dispatch(removeBlockOut({wallIndex, id: blockOut.id})))
            cRails.forEach(cRail => dispatch(removeCRail({wallIndex, id: cRail.id})))
            groundings.forEach(grounding => dispatch(removeGrounding({wallIndex, id: grounding.id})))
            drainages.forEach(drainage => dispatch(removeWallDrainage({wallIndex, id: drainage.id})))
        })
    }
    if (floor) {
        floor.drainages.forEach(drainage => dispatch(removeDrainage({id: drainage.id})))
    }
}

